import { useMemo } from "react";

import { CMSImage } from "common/blocks/Image/cms-image";
import { ResolvedImage } from "resolvers/data/imageResolver";
import { VehicleService } from "services/vehicle/vehicle";
import Swiper from "swiper";
import { Keyboard, Mousewheel, Navigation, Thumbs, Zoom } from "swiper/modules";
import { Swiper as CarouselSwiper, SwiperProps, SwiperSlide } from "swiper/react";
import { SwiperOptions } from "swiper/types";

const ThumbsSwiper = ({
    swiperRef,
    zoomEnabled = false,
    handleOnSwiperThumbs,
    combinedImages,
    cmsMedia,
    slidesPerView,
    className,
    ...swiperProps
}: {
    swiperRef: Swiper | null;
    zoomEnabled: boolean;
    handleOnSwiperThumbs?: (swiper: Swiper) => void;
    combinedImages: VehicleService.MarketingImage[];
    cmsMedia?: ResolvedImage[];
    slidesPerView: SwiperOptions["slidesPerView"];
} & SwiperProps) => {
    const images = useMemo(() => {
        return cmsMedia
            ? cmsMedia.map((cmsImage) => (
                  <SwiperSlide style={{ overflow: "hidden" }} key={`thumb-${cmsImage.alt}`}>
                      {/* eslint-disable-next-line @next/next/no-img-element */}
                      <CMSImage
                          src={cmsImage.src}
                          alt={cmsImage.alt}
                          width={178}
                          height={134}
                          style={{ objectFit: "cover", height: "auto" }}
                      />
                  </SwiperSlide>
              ))
            : combinedImages.map((image, index) => (
                  <SwiperSlide style={{ overflow: "hidden" }} key={`thumb-${image.Angle}`}>
                      {/* eslint-disable-next-line @next/next/no-img-element */}
                      {image.SourceId == 3 ? (
                          <picture key={index}>
                              {image.SizedImages.map((i, index) => {
                                  let mediaQueryString: string;
                                  switch (i.Size) {
                                      case "ExtraSmall":
                                          mediaQueryString = "(min-width: 1024px)";
                                          break;
                                      default:
                                          return;
                                  }
                                  return (
                                      <source
                                          key={index}
                                          media={mediaQueryString}
                                          srcSet={i.Uri}
                                          type={`image/${i.Format}`}
                                      />
                                  );
                              })}
                              <img
                                  src={image.Uri}
                                  alt={image.Description}
                                  width={178}
                                  height={134}
                                  style={{ objectFit: "cover", height: "auto" }}
                                  loading="lazy"
                              />
                          </picture>
                      ) : (
                          <img
                              src={image.Uri}
                              alt={image.Description}
                              width={178}
                              height={134}
                              style={{ objectFit: "cover", height: "auto" }}
                              loading="lazy"
                          />
                      )}
                  </SwiperSlide>
              ));
    }, [cmsMedia, combinedImages]);

    return (
        <CarouselSwiper
            mousewheel={true}
            keyboard={true}
            navigation={{
                nextEl: "#galleryThumbnailNextButton",
                prevEl: "#galleryThumbnailPrevButton",
            }}
            direction="vertical"
            slidesPerView={slidesPerView}
            spaceBetween={10}
            watchSlidesProgress={true}
            loop
            modules={[Navigation, Thumbs, Mousewheel, Keyboard, Zoom]}
            onSwiper={handleOnSwiperThumbs}
            {...swiperProps}
            className={className}
        >
            {images}
        </CarouselSwiper>
    );
};

export default ThumbsSwiper;
